jQuery(document).ready(function ($) {
	var alertBarHidden = false;
	var alertBarHeight = $('.fixed-wrap .alertBar').innerHeight();
	var navHeight = $('.fixed-wrap .navigation').innerHeight();
	var headerHeight = alertBarHeight + navHeight;

	// Offset content from fixed header
	function headerOffset() {

		$('#main').css('padding-top', headerHeight + 'px');

		$('.navigation__mobileMenu').css('height', 'calc( 100vh - ' + headerHeight + 'px )');

		$(window).on('scroll resize', function () {

			if ($(window).scrollTop() >= 250) {
				$('.fixed-wrap').addClass('scrolling');
			} else {
				$('.fixed-wrap').removeClass('scrolling');
			}
		});
	}
	
	// Init header offset function
	headerOffset();

	// Update offset on scroll
	$(window).on('scroll resize', function () {
		headerOffset();
	});

	// Update offset on alert bar close
	$('.alert-bar .close--alert').on('click', function () {
		$('.alertBar').remove();
		alertBarHidden = true;
		alertBarHeight = 0;
		headerOffset();
	});

	var mobileMenuOpen = false;
	$('.navigation__mobileButton').on('click', function () {
		if (mobileMenuOpen) {
			$('.navigation__mobileMenu').hide();
			$('.navigation__mobileButton').removeClass('navigation__mobileButton--open');
			$('html, body').removeClass('no-scroll');
			mobileMenuOpen = false;
		} else {
			$('.navigation__mobileMenu').show();
			$('.navigation__mobileButton').addClass('navigation__mobileButton--open');
			$('html, body').addClass('no-scroll');
			mobileMenuOpen = true;
		}
	});

	function getMenuData(){
		var menuData = [];
		$('.navItem').each(function(){
			var menuItem = $(this);
			var menuItemText = menuItem.find('.navItem__inner span').text();
			var menuItemLink = menuItem.find('.navItem__inner').attr('href');
			var menuItemType = "link";
			if (menuItem.find('.navItem__dropDown').length > 0) {
				menuItemType = "sub";
			}
			if (menuItem.find('.btn').length > 0) {
				menuItemType = "button";
			}
			var menuItemSubmenu = [];
			menuItem.find('.simpleNavChild').each(function(){
				var submenuItem = $(this);
				var submenuItemText = submenuItem.find('.simpleNavChild__link').text();
				var submenuItemLink = submenuItem.find('.simpleNavChild__link').attr('href');
				menuItemSubmenu.push({
					name: submenuItemText,
					link: submenuItemLink
				});
			});
			menuData.push({
				name: menuItemText,
				link: menuItemLink,
				submenu: menuItemSubmenu,
				type: menuItemType
			});
		});
		return menuData;
	}

	var listItemTemplate = `
		<div class="navigation__mobileMenuBlock">
			<div class="navigation__mobileMenuBlockItem">
				<a class="navigation__mobileMenuBlockLink navigation__mobileMenuBlockLink--link" href="{{ link }}"><span class="navigation__mobileMenuBlockLinkText">{{ name }}</span></a>
			</div>
		</div>
	`;

	var listSubTemplate = `
		<div class="navigation__mobileMenuBlock">
			<div class="navigation__mobileMenuBlockItem">
				<button class="navigation__mobileMenuBlockLink navigation__mobileMenuBlockLink--sub">
					<img class="navigation__mobileMenuBlockLinkIcon" src="https://cdn.shopify.com/s/files/1/0713/0513/4247/files/arrow_3.png?v=1757973725" alt="Arrow" width="40" height="40" style="display:none;">
					<span class="navigation__mobileMenuBlockLinkText">{{ name }}</span>
				</button>
			</div>
			<div class="navigation__mobileMenuBlockSub" style="display:none;">
				{{ submenu }}
			</div>
		</div>
	`;

	var listButtonTemplate = `
		<div class="navigation__mobileMenuBlock">
			<div class="navigation__mobileMenuBlockItem">
				<a class="navigation__mobileMenuBlockLink navigation__mobileMenuBlockLink--button" href="{{ link }}"><span class="btn btn--red">{{ name }}</span></a>
			</div>
		</div>
	`;

	var listChildTemplate = `
		<div class="navigation__mobileMenuBlockSub">
			<a class="navigation__mobileMenuChildLink" href="{{ link }}"><span class="navigation__mobileMenuChildLinkText">{{ name }}</span></a>
		</div>
	`;

	function renderMenu(menuData){
		var menuHtml = '';
		for (var i = 0; i < menuData.length; i++) {
			var menuItem = menuData[i];
			
			if (menuItem.submenu.length > 0 && menuItem.type == "sub") {
				var submenuHtml = '';
				for (var j = 0; j < menuItem.submenu.length; j++) {
					var submenuItem = menuItem.submenu[j];
					submenuHtml += listChildTemplate.replace('{{ name }}', submenuItem.name).replace('{{ link }}', submenuItem.link);
				}
				menuHtml += listSubTemplate.replace('{{ name }}', menuItem.name).replace('{{ link }}', menuItem.link).replace('{{ submenu }}', submenuHtml);
			} else if (menuItem.type == "link") {
				menuHtml += listItemTemplate.replace('{{ name }}', menuItem.name).replace('{{ link }}', menuItem.link);
			} else if (menuItem.type == "button") {
				menuHtml += listButtonTemplate.replace('{{ name }}', menuItem.name).replace('{{ link }}', menuItem.link);
			}
		}
		return menuHtml;
	}

	function bindMenu(){
		$('.navigation__mobileMenuBlockLink--sub').on('click', function() {
			var container = $(this).closest('.navigation__mobileMenuBlock');
			var submenu = container.find('.navigation__mobileMenuBlockSub');
			if (container.hasClass('navigation__mobileMenuBlockSub--open')) {
				submenu.hide();
				container.removeClass('navigation__mobileMenuBlockSub--open');

				$('.navigation__mobileMenuBlocks').removeClass('navigation__mobileMenuBlocks--sub-open');
			} else {
				submenu.show();
				container.addClass('navigation__mobileMenuBlockSub--open');

				$('.navigation__mobileMenuBlocks').addClass('navigation__mobileMenuBlocks--sub-open');
			}
		});
	}

	var menuData = getMenuData();
	console.log(menuData);
	var menuHtml = renderMenu(menuData);
	$('.navigation__mobileMenuBlocks').html(menuHtml);
	bindMenu();

});
